import { Link } from 'react-router-dom'

export function MenuPreviewToolbar() {
  return (
    <header className="menu-preview-toolbar sticky top-0 z-50 border-b border-hairline bg-white/95 backdrop-blur-sm">
      <div className="mx-auto flex max-w-[1280px] items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <div>
          <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.2em] text-muted">
            Print menu preview
          </p>
          <p className="mt-0.5 font-sans text-xs text-body">
            Double-sided A4 booklet — flip on screen, then print duplex + booklet. Route: /menu2
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2 sm:gap-3">
          <Link
            to="/"
            className="inline-flex min-h-10 items-center justify-center rounded-[var(--radius-button)] border border-hairline bg-white px-4 font-sans text-[11px] font-semibold uppercase tracking-[0.14em] text-ink no-underline transition-colors hover:bg-ink/[0.04]"
          >
            Back
          </Link>
          <button
            type="button"
            onClick={() => window.print()}
            className="inline-flex min-h-10 items-center justify-center rounded-[var(--radius-button)] bg-primary px-4 font-sans text-[11px] font-semibold uppercase tracking-[0.14em] text-on-primary transition-colors hover:bg-primary-active"
          >
            Print / Save PDF
          </button>
        </div>
      </div>
    </header>
  )
}
